﻿import * as helpers from '../iamkey/assets/js/modules/helpers'
import extendDialogs from '../iamkey/assets/js/modules/dialogs'
import extendInputs from '../iamkey/assets/js/modules/inputs'


function getCookie(name) {
  // Split cookie string and get all individual name=value pairs in an array
  let cookieArr = document.cookie.split(";");

// Loop through the array elements
  for (let i = 0; i < cookieArr.length; i++) {
    let cookiePair = cookieArr[i].split("=");

    /* Removing whitespace at the beginning of the cookie name
    and compare it with the given string */
    if (name == cookiePair[0].trim()) {
        // Decode the cookie value and return
        return decodeURIComponent(cookiePair[1]);
    }
  }

  // Return null if not found
  return null;
}


document.addEventListener('DOMContentLoaded', () => {
  helpers.addBodyClasses(document.body)
  helpers.addGlobalEvents(document.body)
  extendDialogs(document.body)
  extendInputs(document.body)

  // Load components when some
  const components = ['accordion', 'header', 'tabs', 'table', 'card', 'pagination', 'filterlist', 'applied-filters', 'nav', 'marketing', 'notification']
  const prefix = 'iam'
  const componentExt = '.component.min.js'

  components.forEach((component) => {
    if (document.getElementsByTagName(`${prefix}-${component}`).length === 0)
      return

    import(`/assets/iamkey/assets/js/components/${component}/${component}${componentExt}`).then(module => {
      if (!window.customElements.get(`${prefix}-${component}`))
        window.customElements.define(`${prefix}-${component}`, module.default)
    }).catch((err) => {
      console.log(err.message)
    })
  })

  if (document.getElementById('switchAccount')) {
    const switchAccount = document.getElementById('switchAccount')
    const ajaxURL = switchAccount.getAttribute('data-url')

    switchAccount.addEventListener('click', (event) => {
      deleteCookie()
    })

    async function deleteCookie() {
      try {
        await fetch(ajaxURL, {
          method: 'get',
          credentials: 'same-origin'
        }).then((response) => response.json()).then((response) => {
          if (response.Success === true)
            location.reload()

          return response
        })
      }
      catch (error) {
        console.log(error)
      }
    }
  }

  // Cookies agreement
  const cookieButton = document.getElementById('js-cookie-button')

  cookieButton.addEventListener('click', () => {
    document.cookie = `cookie-box=true;max-age=${30 * 24 * 60 * 60}`
    cookieButton.closest('iam-notification').remove()
  })

  if (getCookie('cookie-box'))
    cookieButton.closest('iam-notification').remove()
  else
    cookieButton.closest('iam-notification').classList.remove('d-none')

  // forgotton password
  if (document.getElementById('resetPassword') && document.getElementById('auth-forgot-password')) {
    const resetPassword = document.getElementById('resetPassword')
    const resetPasswordWrapper = document.getElementById('auth-forgot-password')
    const ajaxURL = resetPassword.getAttribute('action')
    const ajaxMethod = resetPassword.getAttribute('method')

    resetPassword.addEventListener('submit', (event) => {
      event.preventDefault()
      resetPasswordSubmit(new FormData(resetPassword))
    })
    async function resetPasswordSubmit(formData) {
      try {
        await fetch(ajaxURL, {
          method: ajaxMethod,
          credentials: 'same-origin',
          body: formData,
        }).then((response) => response.json()).then((response) => {
          if (response.Success === true)
            resetPasswordWrapper.innerHTML = `<h1 class="h3 mt-5">Reset your password</h1><iam-notification class="mb-5">${resetPasswordWrapper.getAttribute('data-success') ?? ''}</iam-notification><a href="/User/login" class="btn btn-primary">Sign in</a>`
          else
            resetPasswordWrapper.innerHTML = `<h1 class="h3 mt-5">Reset your password</h1><iam-notification class="colour-danger mb-5">${resetPasswordWrapper.getAttribute('data-error') ?? ''}</iam-notification><a href="/User/Login" class="btn btn-primary">Sign in</a>`

          return response
        })
      }
      catch (error) {
        console.log(error)
      }
    }
  }


  // Reset password email screen
  if (document.getElementById('newPassword')) {
    const newPassword = document.getElementById('newPassword')
    const newPassworddWrapper = document.getElementById('auth-new-password')
    const ajaxURL = newPassword.getAttribute('action')
    const ajaxMethod = newPassword.getAttribute('method')

    newPassword.addEventListener('submit', (event) => {
      event.preventDefault()
      newPasswordSubmit(new FormData(newPassword))
    })
    async function newPasswordSubmit(formData) {
      try {
        await fetch(ajaxURL, {
          method: ajaxMethod,
          credentials: 'same-origin',
          body: formData,
        }).then((response) => response.json()).then((response) => {
          if (response.Success === true)
            window.location.href = '/user/login'
          else
            newPassworddWrapper.innerHTML = `<iam-notification class="colour-danger mb-5">${response.msg ?? ''}</iam-notification>`

          return response
        })
      }
      catch (error) {
        console.log(error)
      }
    }
  }
})
